import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import {ContractCreate} from '../../../../view/Messages';
import Preview from './Preview';
import Data from '../../../../data/StateOptionContract.json';

class DefaultView extends Component {

    constructor(props) {
        super(props);
        this.state = Data;
    }

    componentWillMount() {

        /*
        * Loggin data to localStorage
        * Form ID mcph102
        */
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					////console.log("Props default: ", this.props);
				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log("State default: ", this.state);
			//console.log("Props default: ", this.props);
		}

	}
	
	componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
    }

    hasPending() {
		if(this.state.details.seller.length) {
			return (
				<p className="mt-5">Looks like you have a pending form.  <Link className="font-weight-bold" to={this.state.formPath+"/1"}>Click Here</Link> to continue editing or <Link className="font-weight-bold" to={this.state.formPath+"/1"} onClick={()=>localStorage.removeItem(this.state.formId)}>Click here</Link> to start all over again.</p>
			);
		}
	}

    render() {
        return (
            <div className="container text-center p-0">
				<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
				<ContractCreate />

				<div className="default-preview">
					<Preview {...this.state} />
					<div className="default-preview-fade"></div>
				</div>

				{this.hasPending()}

				<Link to={this.state.formPath+"/1"} className="btn btn-lightblue">
					Create Your {this.state.formName} Now!
				</Link>
			</div>
        )
    }
}

export default DefaultView;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/option-contract/DefaultView.js